"use strict";
/*
 * @Description: types definition
 * @Author: shijie.zou
 * @Version: entry-task-1.0.0
 * @Date: 2022-04-26 17:50:06
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICountryDomain = exports.IEnv = exports.ICountry = void 0;
var ICountry;
(function (ICountry) {
    ICountry["SG"] = "SG";
    ICountry["MY"] = "MY";
    ICountry["BR"] = "BR";
    ICountry["ID"] = "ID";
    ICountry["TW"] = "TW";
    ICountry["VN"] = "VN";
    ICountry["TH"] = "TH";
    ICountry["PH"] = "PH";
    ICountry["MX"] = "MX";
    ICountry["CO"] = "CO";
    ICountry["CL"] = "CL";
    ICountry["AR"] = "AR";
    ICountry["PL"] = "PL";
    ICountry["ES"] = "ES";
    ICountry["FR"] = "FR";
    ICountry["IN"] = "IN";
    ICountry["CN"] = "CN";
})(ICountry = exports.ICountry || (exports.ICountry = {}));
var IEnv;
(function (IEnv) {
    IEnv["TEST"] = "test";
    IEnv["LIVE"] = "live";
    IEnv["UAT"] = "uat";
    IEnv["STAGING"] = "staging";
    IEnv["TEST_STABLE"] = "test-stable";
})(IEnv = exports.IEnv || (exports.IEnv = {}));
var ICountryDomain;
(function (ICountryDomain) {
    ICountryDomain["SG"] = "sg";
    ICountryDomain["MY"] = "com.my";
    ICountryDomain["BR"] = "com.br";
    ICountryDomain["ID"] = "co.id";
    ICountryDomain["TW"] = "tw";
    ICountryDomain["VN"] = "vn";
    ICountryDomain["TH"] = "co.th";
    ICountryDomain["PH"] = "ph";
    ICountryDomain["MX"] = "com.mx";
    ICountryDomain["CO"] = "com.co";
    ICountryDomain["CL"] = "cl";
    ICountryDomain["AR"] = "com.ar";
    ICountryDomain["PL"] = "pl";
    ICountryDomain["ES"] = "es";
    ICountryDomain["FR"] = "fr";
    ICountryDomain["IN"] = "in";
    ICountryDomain["CN"] = "cn";
})(ICountryDomain = exports.ICountryDomain || (exports.ICountryDomain = {}));
